import { createQueryKeys } from '@lukemorales/query-key-factory';

import { get } from '@/api/api';
import type {
  FanguardApiContractsControllerControllerModel,
  FanguardApiContractsDevicesDeviceModel,
} from 'src/api/generated';

export const CONTROLLERS_URI = 'controllers';

export interface ControllerLogsResponse {
  logs: string;
}

export const controllersQueries = createQueryKeys(CONTROLLERS_URI, {
  all: null,
  detail: (id: string) => ({
    queryKey: [id],
    queryFn: async () => {
      const response = await get<FanguardApiContractsDevicesDeviceModel>({ uri: `${CONTROLLERS_URI}/${id}` });
      return response.data;
    },
  }),
  list: (venueId?: string | null) => ({
    queryKey: [venueId ?? 'all'],
    queryFn: async () => {
      const response = await get<FanguardApiContractsControllerControllerModel[]>({
        uri: venueId ? `${CONTROLLERS_URI}?venueId=${venueId}` : CONTROLLERS_URI,
      });
      return response.data;
    },
  }),
  logs: (id: string, lineCount?: number) => ({
    queryKey: [id, lineCount ?? 'all'] as const,
    queryFn: async () => {
      const suffix = lineCount ? `?lineCount=${lineCount}` : '';
      const response = await get<ControllerLogsResponse>({
        uri: `${CONTROLLERS_URI}/${id}/log${suffix}`,
      });
      return response.data;
    },
  }),
});
